module.exports = __webpack_public_path__ + "static/media/pack.cd27951d.png";